import * as React from "react";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button, Menu } from "@mui/material";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import {
  ChangeCircle,
  ContactPhone,
  Delete,
  Email,
  Sms,
  SupportAgent,
} from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function SelectActionMenu({
  forTable = "ManageLeads",
  onSelectOption,
  handleOnOpen,
  selectedLeads,
  isdisabled,
  canPasswordBeReseted = false,
}) {
  const userDetails = useSelector(
    (state) => state.user.userDetails || { UserDetails: {} },
  );

  const roleName = (userDetails?.UserDetails?.role ?? "")
    .toString()
    .trim()
    .toLowerCase();
  const isSalesUserOrManager =
    roleName === "sales user" || roleName === "sales manager";
  const canEditLead =
    roleName === "administrator" || roleName === "strategy";

  const userPermissions = userDetails ? userDetails.useraccess : [];

  const manageLeadsPermissions =
    userPermissions.find((perm) => perm.modulename === "Manage Leads") || {};

  const canEditManageLeads = manageLeadsPermissions?.edit;
  const canDeleteManageLeads = manageLeadsPermissions?.delete;

  const manageUsersPermissions =
    userPermissions.find((perm) => perm.modulename === "Manage Users") || {};

  const canEditManageUsers = manageUsersPermissions?.edit;
  const canDeleteManageUsers = manageUsersPermissions?.delete;
  const canChangePassword = manageUsersPermissions?.resetpassword;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    // handleOnOpen();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectOption = (selectedItem) => {
    onSelectOption(selectedItem);
    handleClose();
  };

  const commonSx = {
    ":hover": {
      backgroundColor: "rgba(42, 131, 255, 0.2)",
    },
  };

  return (
    <Box>
      <Tooltip
        title={
          forTable === "ManageUsers"
            ? "User Actions"
            : forTable === "LeadDistributionRatio"
              ? "Lead Distribution Actions"
              : "Lead Actions"
        }
      >
        <Button
          disabled={isdisabled}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          variant="filled"
          sx={{
            color: "#ffffff",
            ":disabled": {
              backgroundColor: "#6A6B6E",
              color: "#ffffff",
            },
            backgroundColor: "#3A36DB",
            ":hover": {
              backgroundColor: "#3A36DB",
            },
            fontSize: {
              xs: 10,
              sm: 10,
              md: 12,
              lg: 12,
              xl: 12,
            },
            width: {
              xs: 100,
              sm: 100,
              md: 110,
              lg: 110,
              xl: 110,
            },
          }}
        >
          Actions
        </Button>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {forTable === "LeadDistributionRatio" ? (
          <MenuList>
            {selectedLeads.length === 1 && (
              <MenuItem
                sx={commonSx}
                onClick={() => handleSelectOption("Update Ratio")}
              >
                <ListItemIcon>
                  <EditIcon fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Update Ratio</ListItemText>
              </MenuItem>
            )}
          </MenuList>
        ) :
          forTable !== "ManageUsers" ? (
            <MenuList>
              {forTable !== "Activities" &&
                (canEditManageLeads === "1" || canEditManageLeads === "2") && (
                  <MenuItem
                    sx={commonSx}
                    onClick={() => handleSelectOption("Bulk Update")}
                  >
                    <ListItemIcon>
                      <DynamicFeedIcon fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Bulk Update</ListItemText>
                  </MenuItem>
                )}

              {forTable !== "Activities" &&
                canEditLead &&
                (canEditManageLeads === "1" || canEditManageLeads === "2") &&
                selectedLeads.length === 1 && (
                  <MenuItem
                    sx={commonSx}
                    onClick={() => handleSelectOption("Edit Lead")}
                  >
                    <ListItemIcon>
                      <EditIcon fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Edit Lead</ListItemText>
                  </MenuItem>
                )}

              {forTable !== "Activities" &&
                (canEditManageLeads === "1" || canEditManageLeads === "2") && (
                  <MenuItem
                    sx={commonSx}
                    onClick={() => handleSelectOption("Change Owner")}
                  >
                    <ListItemIcon>
                      <ChangeCircle fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Change Owner</ListItemText>
                  </MenuItem>
                )}

              {canDeleteManageLeads === "1" && (
                <MenuItem
                  sx={commonSx}
                  onClick={() => handleSelectOption("Delete")}
                >
                  <ListItemIcon>
                    <Delete fontSize="medium" />
                  </ListItemIcon>
                  <ListItemText>Delete</ListItemText>
                </MenuItem>
              )}

              <MenuItem sx={commonSx} onClick={() => handleSelectOption("SMS")}>
                <ListItemIcon>
                  <Sms fontSize="medium" />
                </ListItemIcon>
                <ListItemText>SMS</ListItemText>
              </MenuItem>

              <MenuItem
                sx={commonSx}
                onClick={() => handleSelectOption("Whatsapp")}
              >
                <ListItemIcon>
                  <WhatsAppIcon fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Whatsapp</ListItemText>
              </MenuItem>

              <MenuItem sx={commonSx} onClick={() => handleSelectOption("Email")}>
                <ListItemIcon>
                  <Email fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Email</ListItemText>
              </MenuItem>

              {!isSalesUserOrManager && (
                <>
                  <MenuItem
                    sx={commonSx}
                    onClick={() => handleSelectOption("Tele Access")}
                  >
                    <ListItemIcon>
                      <SupportAgent fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Tele Access</ListItemText>
                  </MenuItem>

                  <MenuItem
                    sx={commonSx}
                    onClick={() => handleSelectOption("Ameyo")}
                  >
                    <ListItemIcon>
                      <ContactPhone fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Ameyo</ListItemText>
                  </MenuItem>
                </>
              )}
            </MenuList>
          ) : (
            <MenuList>
              {(canEditManageUsers === "1" || canEditManageUsers === "2") && (
                <MenuItem
                  sx={commonSx}
                  onClick={() => handleSelectOption("BUlk Edit")}
                >
                  <ListItemIcon>
                    <DynamicFeedIcon fontSize="medium" />
                  </ListItemIcon>
                  <ListItemText>Bulk Edit</ListItemText>
                </MenuItem>
              )}

              {(canEditManageUsers === "1" || canEditManageUsers === "2") &&
                selectedLeads.length === 1 && (
                  <MenuItem
                    sx={commonSx}
                    onClick={() => handleSelectOption("Edit User")}
                  >
                    <ListItemIcon>
                      <EditIcon fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Edit User</ListItemText>
                  </MenuItem>
                )}

              {canDeleteManageUsers === "1" && (
                <MenuItem
                  sx={commonSx}
                  onClick={() => handleSelectOption("Delete")}
                >
                  <ListItemIcon>
                    <ChangeCircle fontSize="medium" />
                  </ListItemIcon>
                  <ListItemText>Delete</ListItemText>
                </MenuItem>
              )}

              {(canEditManageUsers === "1" ||
                (canChangePassword === 1 && canPasswordBeReseted)) && (
                  <MenuItem
                    sx={commonSx}
                    onClick={() => handleSelectOption("Reset")}
                  >
                    <ListItemIcon>
                      <Delete fontSize="medium" />
                    </ListItemIcon>
                    <ListItemText>Password Reset</ListItemText>
                  </MenuItem>
                )}
            </MenuList>
          )}
      </Menu>
    </Box>
  );
}
